@let vdrJob = vdrJob$ | async;

<header class="grid grid-cols-12 header px-[32px] py-7 rounded-lg">
  <div class="col-span-4">
    <div class="flex items-center gap-5">
      <img src="/assets/header-logo.png" alt="Logo" />
      <span class="text-2xl font-medium leading-[141%] uppercase text-white">DIAGNOSE</span>
    </div>
  </div>
  <div class="col-span-8">
    <div class="flex items-center justify-end gap-16">
      @if (vdrJob) {
        <div class="flex gap-16">
          <div class="flex flex-col gap-2 text-white">
            <h4 class="text-sm font-bold leading-[22px] capitalize">Project Name</h4>
            <p class="font-normal leading-[22px]">{{ vdrJob.projectName || '' }}</p>
          </div>
          <div class="flex flex-col gap-2 text-white">
            <h4 class="text-sm font-bold leading-[22px]">Project ID</h4>
            <p class="font-normal leading-[22px]">{{ vdrJob.projectId || '' }}</p>
          </div>
          <div class="flex flex-col gap-2 text-white">
            <h4 class="text-sm font-bold leading-[22px] uppercase">PLO#/SO#</h4>
            <p class="font-normal leading-[22px]">{{ vdrJob.soNumber || '' }}</p>
          </div>
        </div>
      } @else if (mode3ProjectId()) {
        <!-- Mode 3 header block. VDRJob block is Mode 2 only; Mode 3 has its own project context. -->
        <div class="flex items-center gap-16">
          <div class="flex flex-col gap-2 text-white">
            <h4 class="text-sm font-bold leading-[22px]">Project ID</h4>
            <p class="font-normal leading-[22px]">{{ mode3DisplayId() || '' }}</p>
          </div>
        </div>
      }
      <div class="flex items-center justify-end">
        <p-menu #menu [model]="items()" [popup]="true" styleClass="menu-user" appendTo="body" />
        <p-avatar [label]="labelAvatar" class="mr-2" size="normal" shape="circle" styleClass="avatar-user-v2" (click)="menu.toggle($event)" />
      </div>
    </div>
  </div>
</header>
